export default {"src":"/_next/static/media/alertIcon.e67b10c3.svg","height":38,"width":43,"blurWidth":0,"blurHeight":0};